import axios from "axios";
import config from "./config";

const baseURL = config.SERVER_BASE_URL;

const axiosInstance = axios.create({
  baseURL: baseURL, // Your API base URL
  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosInstance;
